var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"title":_vm.title,"visible":_vm.dialogFormVisible,"center":"","width":"800px"},on:{"update:visible":function($event){_vm.dialogFormVisible=$event}}},[_c('form-template',{ref:"formTemplate",on:{"success":_vm.backParent,"getDetailSuccess":_vm.getDetailSuccess,"submit":_vm.submit}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44650644","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/template/add.vue
// module id = null
// module chunks = 